import _taggedTemplateLiteral from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
export var Container = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: ", ";\n  background: ", ";\n  border-radius: 5px;\n  padding: 15px 20px;\n  cursor: pointer;\n  width: 100%;\n"])), function (props) {
  return props.isSelected ? '1px solid #1F35B5' : '1px dashed #A7A7A7';
}, function (props) {
  return props.isSelected ? '#E8EAF8' : 'none';
});